module.exports = __webpack_public_path__ + "static/media/Fabrication Remote Entry.9ec5c8e8.png";